import Vue from 'vue';
import { computed } from '@vue/composition-api';
export default Vue.extend({
    props: {
        validator: {
            type: Object,
            required: true
        },
        mandatoryErrMsg: {
            type: String,
            required: false
        },
        minLengthErrMsg: {
            type: String,
            required: false
        },
        maxLengthErrMsg: {
            type: String,
            required: false
        },
        textOnlyErrMsg: {
            type: String,
            required: false
        },
        numbersOnlyErrMsg: {
            type: String,
            required: false
        },
        alphaNumErrMsg: {
            type: String,
            required: false
        },
        emailErrMsg: {
            type: String,
            required: false
        },
        sameAsValueErrMsg: {
            type: String,
            required: false
        },
        dobFormatErrMsg: {
            type: String,
            required: false
        },
        dobMandatoryErrMsg: {
            type: String,
            required: false
        }
    },
    setup(props, { root }) {
        const content = computed(() => root.$store.state.Content.content);
        return {
            content
        };
    }
});
